import React from "react";
import { motion } from "framer-motion";
import {
  ShieldCheck, Leaf, GraduationCap, Wrench, MoveUp, Home,
  Droplet, Box, Cog, Hammer, Siren, Megaphone, Package, ArrowUpRight, Link2,
} from "lucide-react";
import { SERVICES } from "../../data/hseData";

const ICONS = {
  ShieldCheck, Leaf, GraduationCap, Wrench, MoveUp, Home,
  Droplet, Box, Cog, Hammer, Siren, Megaphone, Package,
  LinkIcon: Link2,
};

export const Services = () => {
  return (
    <section id="servicos" data-testid="section-servicos" className="relative py-24 sm:py-32 bg-[#081726]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-8">
            <div className="inline-flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#2FA36B]" />
              <span className="font-condensed uppercase text-xs tracking-[0.4em] text-[#2FA36B] font-bold">
                Serviços
              </span>
            </div>
            <h2 className="font-condensed font-bold uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tight">
              Soluções técnicas para
              <span className="text-[#2FA36B]"> atividades críticas</span>.
              <span className="block text-white/70 text-2xl sm:text-3xl lg:text-4xl mt-4 normal-case">Sua empresa não pode parar.</span>
            </h2>
          </div>
          <p className="lg:col-span-4 text-white/65 font-body text-base leading-relaxed">
            A HSE oferece soluções completas para empresas que precisam executar trabalhos de alto risco com planejamento, equipe qualificada, equipamentos adequados, controle de riscos e atendimento aos requisitos legais aplicáveis.
          </p>
        </div>

        {/* Services bento */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/[0.07] border border-white/[0.07]">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || ShieldCheck;
            return (
              <motion.div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.4, delay: (i % 3) * 0.08 }}
                className="bg-[#12283F] hover:bg-[#173250] transition-colors p-7 sm:p-8 group relative"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-12 h-12 border border-white/15 flex items-center justify-center group-hover:border-[#2FA36B] group-hover:bg-[#2FA36B] transition-all">
                    <Icon size={22} strokeWidth={1.75} className="text-white" />
                  </div>
                  <span className="font-condensed font-bold text-[10px] tracking-[0.3em] uppercase text-white/30">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>

                <h3 className="font-condensed font-bold uppercase text-xl sm:text-2xl text-white tracking-tight leading-tight mb-5">
                  {s.title}
                </h3>

                <ul className="space-y-2 mb-6">
                  {s.items.map((it) => (
                    <li key={it} className="flex items-start gap-2 text-white/65 font-body text-sm leading-snug">
                      <span className="w-1 h-1 bg-[#2FA36B] mt-2 shrink-0" />
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#contato"
                  data-testid={`service-cta-${s.id}`}
                  className="inline-flex items-center gap-2 font-condensed uppercase text-[11px] tracking-[0.25em] text-white/70 group-hover:text-[#2FA36B] font-bold transition-colors"
                >
                  Solicitar este serviço
                  <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </a>
              </motion.div>
            );
          })}
        </div>

        {/* CTA banner */}
        <div className="mt-16 border border-[#2FA36B]/40 bg-gradient-to-r from-[#2FA36B]/15 via-[#0B1B2D] to-[#0B1B2D] p-8 sm:p-12 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div>
            <p className="font-condensed uppercase text-xs tracking-[0.3em] text-[#2FA36B] font-bold mb-3">
              Atividade Crítica?
            </p>
            <h3 className="font-condensed font-bold uppercase text-3xl sm:text-4xl text-white tracking-tight leading-tight">
              Quando o serviço é crítico,
              <br className="hidden sm:block" /> a segurança precisa ser especializada.
            </h3>
          </div>
          <a
            href="#contato"
            data-testid="services-banner-cta"
            className="shrink-0 inline-flex items-center gap-3 font-condensed uppercase text-sm tracking-[0.2em] font-bold bg-[#2FA36B] hover:bg-[#37B87A] text-white px-7 py-5 transition-colors"
          >
            Solicitar avaliação técnica
            <ArrowUpRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
